export enum PedidoOrigem {
	TELEATENDIMENTO = <any>'teleatendimento',
	PORTARIA = <any>'portaria',
	APLICATIVO = <any>'aplicativo',
	QRCODEAPP = <any>'qrcodeapp'
}
